import { render, staticRenderFns } from "./CbxPersonalRelation.vue?vue&type=template&id=f80df8a8&"
import script from "./CbxPersonalRelation.vue?vue&type=script&lang=ts&"
export * from "./CbxPersonalRelation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports